import { Tooltip } from "antd";
import CreateButton from "components/CreateButton";

function LoyaltyDetailEditButton({ label, disabled = false, disabledTooltip, onClick, className = "" }) {
  const button = (
    <CreateButton
      title={label}
      className={["btn-create", "loyalty-detail-edit-btn", disabled && "loyalty-detail-edit-btn--disabled", className]
        .filter(Boolean)
        .join(" ")}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    />
  );

  if (disabled && disabledTooltip) {
    return (
      <span className="loyalty-detail-edit-btn-wrap">
        <Tooltip title={disabledTooltip}>{button}</Tooltip>
      </span>
    );
  }

  return button;
}

export default LoyaltyDetailEditButton;
